/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 02.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import BaseResourceContainer from "../../BaseResourceContainer";
import ViewRecord from "./ViewRecord";
import SchemaRegistry from "../../../../services/SchemaRegistry";
import DataProvider from "../../../../DataProvider";
import {deepEquals} from "../../../../util";
import LocationInfo from "../../../../LocationInfo";

class ViewRecordContainer extends BaseResourceContainer {
    static propTypes = {
        basePath: PropTypes.string.isRequired,
        params: PropTypes.shape({
            path: PropTypes.string.isRequired,
            resource: PropTypes.string.isRequired,
            id: PropTypes.string,
            query: PropTypes.object,
            parentResource: PropTypes.string,
            parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
            parentField: PropTypes.string
        }).isRequired,
        schema: PropTypes.string.isRequired
    };

    static defaultProps = {};


    shouldComponentUpdate(nextProps, nextState) {
        return !deepEquals(this.props.params, nextProps.params) || nextProps.schema !== this.props.schema || this.state !== nextState;
    }

    getDataProvider() {
        let schema = SchemaRegistry.getSchemaObject(this.props.params.parentResource, this.props.params.resource, this.props.schema);
        if (this.props.params.parentResource && this.props.params.parentField) {
            let dataProvider = null;
            switch (this.props.params.parentAction) {
                case "edit":
                case "new":
                    dataProvider = new DataProvider(schema, this.state.resource.editRecord);
                    break;

                case "view":
                default:
                    dataProvider = new DataProvider(schema, this.state.resource.currentRecord);
            }
            //let locationInfo = new LocationInfo(this.props.basePath, this.props.params.path, this.props.params.query);
            //let field = locationInfo.getJsonSchemaFieldPath();
            //return dataProvider.getProvider(field);
            return dataProvider;

        } else {
            return new DataProvider(schema, this.state.resource.currentRecord);
        }
    }

    render() {
        let dataProvider = this.getDataProvider();
        if (!this.state.resource || !dataProvider.getData()) return null;
        return (
            <ViewRecord
                dataProvider={dataProvider}
                />
        );
    }
}

export default ViewRecordContainer;
